import React from "react";

const ThemeBg5 = (props) => {
  const {currentColor, secondColor} = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="354"
      height="227"
      fill="none"
      viewBox="0 0 354 227"
    >
      <mask
        id="mask0_3458_14072"
        style={{ maskType: "alpha" }}
        width="354"
        height="227"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <rect
          width="353"
          height="226.006"
          x="0.885"
          y="0.424"
          fill="#C4C4C4"
          rx="5"
        ></rect>
      </mask>
      <g mask="url(#mask0_3458_14072)">
        <path
          fill={secondColor}
          d="M-128.522 -6.326H383.906V235.156H-128.522z"
        ></path>
        <path
          stroke={currentColor}
          strokeMiterlimit="10"
          strokeWidth="0.641"
          d="M-146.774 347.301l115.272-180.488L94.723-6.326 218.04 112.8l128.987 147.104M94.723-6.326l.474 488.39"
        ></path>
        <path
          stroke={currentColor}
          strokeMiterlimit="10"
          strokeWidth="0.16"
          d="M71.062 26.13L-74.335 384.395M119.359 17.467l147.058 272.977M93.356-4.45L76.699 460.093M96.13-4.971l23.228 461.253M74.21 21.805L34.185 122.631 57.42 93.398 82.829 9.992M32.098 127.897l-6.35 15.991 26.549-33.678 4.023-13.208-24.222 30.895zM23.112 150.542L14.32 172.68l30.652-38.416 5.67-18.608-27.53 34.886zM11.672 179.354L-1.25 211.89l35.963-43.955 8.305-27.257-31.346 38.676zM35.446 199.363l7.732-31.782 40.031-48.494M68.98 63.705l20.333-26.783M45.079 95.2l19.526-25.722M71.388 55.256L89.86 30.882M49.422 84.255l18.03-23.8M66.246 74.217l22.487-29.466M39.495 109.256l21.787-28.538M80.634 153.832l-4.269 57.511-70.49 79.855 20.152-72.594 54.607-64.772z"
        ></path>
        <path
          stroke={currentColor}
          strokeMiterlimit="10"
          strokeWidth="0.16"
          d="M29.416 206.384l51.906-61.802 2.428-32.73-42.827 53.092-11.507 41.44zM50.456 130.593L86.03 85.997l-1.407 19.962-41.446 50.863 7.278-26.229zM88.092 55.643l-.674 9.43-29.344 37.816 3.855-13.856 26.163-33.39zM92.275-2.969l-3.983 55.856-25.362 32.55 21.693-77.9M87.299 67.93l-1 14.296-34.696 43.849 5.063-18.761L87.3 67.93zM80.114 160.853L28.402 221.26l-15.116 61.041M18.903 219.832l13.335-43.775-37.49 45.931-19.299 48.607 43.454-50.763z"
        ></path>
        <path
          stroke={currentColor}
          strokeMiterlimit="10"
          strokeWidth="0.16"
          d="M29.416 185.321l-32.52 39.237-13.823 37.308M47.26 151.81l5.544-20.009 32.854-40.465M55.165 121.576l3.543-13.181 28.31-36.494M73.33 48.355L90.2 26.13M53.09 75.025l16.33-21.518M74.957 42.241l15.57-20.67M56.233 67.109l15.41-20.47M76.392 37.09L90.788 17.92M58.894 60.402L73.33 41.174M77.633 32.63l13.361-17.626M61.423 54.021l13.415-17.7M78.66 28.94L91.18 12.362M63.31 49.27l12.842-17.013M79.767 24.955l11.608-15.31M65.478 43.803L77.26 28.266M80.634 21.846L91.528 7.489M67.14 39.632l11.286-14.877M81.749 18.348l9.94-13.068M68.86 35.294l10.287-13.529M82.395 15.538l9.44-12.287M70.655 30.815l9.58-12.467M83.356 12.081L92.016.675M72.283 26.664l9.125-12.02M19.777 165.839l5.056-14.029 24.055-30.401M4.207 205.229l10.113-24.801 26.45-32.369M-24.551 328.68L95.197 196.173M106.244 4.8l26.189 74.463-30.078-27.631-5.25-55.662M116.83 15.024l49.825 95.8-28.091-25.515-30.592-78.407M195.186 165.685l16.29 31.322-45.348-41.039-9.753-25.001 38.811 34.718zM154.207 125.414l-7.204-18.467 33.04 29.633 11.794 22.678-37.63-33.844zM145.422 102.889l-5.304-13.595 28.918 26.109 8.539 16.418-32.153-28.932zM169.737 165.212l16.95 43.448 55.655 47.7-25.843-49.682-46.762-41.466zM249.8 270.702l5.957 11.453 39.505 76.078-74.387-61.949-29.325-75.164 58.25 49.582zM103.495 63.705l-.907-9.584 30.926 28.205 4.723 13.441-34.742-32.062zM105.09 80.577l-1.314-13.875 35.775 32.79 6.217 17.679-40.678-36.594zM107.118 102.121l-1.675-17.753 42.113 37.896 9.033 25.682-49.471-45.825zM110.913 142.359l-3.028-32.122 51.372 45.304 14.589 41.466-62.933-54.648zM117.424 211.343l-5.637-59.753 65.875 56.282 26.129 74.283-86.367-70.812zM109.065 9.511l9.4 8.79M97.552-1.728l9.532 8.91M110.053 12.081l10.6 10.051M97.618.228l10.527 9.978M111.114 15.004l11.567 11.133M97.852 2.724l11.434 10.999M112.788 19.242l12.194 11.64M98.085 5.868l12.581 12.006M114.422 23.334l13.048 12.2M98.339 8.991l13.989 13.088M116.277 28.2l14.068 13.034M98.6 11.815l15.002 13.902M117.851 32.224l15.123 14.009M98.866 14.644l15.97 14.79M119.505 36.462l16.691 15.69M99.12 17.3l17.337 16.298M121.66 41.68l17.891 16.92M99.433 20.657l18.565 17.56M123.788 47.44l19.379 18.2M99.84 24.956l20.146 18.92M126.396 54.121l21.567 20.27M100.28 29.587l22.014 20.683M129.825 62.911l22.728 21.344M100.854 35.72l24.281 22.793M133.734 72.942l25.109 23.306M101.547 43.07l26.784 24.86"
        ></path>
        <path
          stroke={currentColor}
          strokeMiterlimit="10"
          strokeWidth="0.16"
          d="M113.775 172.68l54.307 46.144 12.161 43.602M104.156 70.68l34.081 31.274 4.169 12.194M105.864 88.826l39.904 35.92 6.171 18.895M108.559 117.378l47.062 41.74 10.587 31.255M158.843 137.294l34.048 30.694 11.254 22.385M148.817 111.585l29.905 27.277 6.858 14.763M172.652 172.68l41.246 36.333 21.206 41.146M131.019 28.733L325.3 340.847M142.406 39.732l191.206 278.416M153.313 50.27l181.794 248.257M64.378 35.294l-150.68 321.951M56.233 46.233L-131.705 416.67M46.04 60.455l-194.288 364.112"
        ></path>
        <path
          fill={currentColor}
          d="M172.529 -6.326H383.905V235.156H172.529z"
        ></path>
        <mask
          id="mask1_3458_14072"
          style={{ maskType: "alpha" }}
          width="212"
          height="243"
          x="172"
          y="-7"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#781B1B"
            d="M172.529 -6.326H383.905V235.156H172.529z"
          ></path>
        </mask>
        <g stroke={secondColor} strokeMiterlimit="10" mask="url(#mask1_3458_14072)">
          <path
            strokeWidth="0.641"
            d="M-146.774 347.301l115.272-180.488L94.723-6.326 218.04 112.8l128.987 147.104"
          ></path>
          <path
            strokeWidth="0.16"
            d="M119.359 17.467l147.058 272.977M195.186 165.685l16.29 31.322-45.348-41.039-9.753-25.001 38.811 34.718zM154.207 125.414l-7.204-18.467 33.04 29.633 11.794 22.678-37.63-33.844zM145.422 102.889l-5.304-13.595 28.918 26.109 8.539 16.418-32.153-28.932zM169.737 165.212l16.95 43.448 55.655 47.7-25.843-49.682-46.762-41.466zM249.8 270.702l5.957 11.453 39.505 76.078-74.387-61.949-29.325-75.164 58.25 49.582zM110.913 142.359l-3.028-32.122 51.372 45.304 14.589 41.466-62.933-54.648zM117.424 211.343l-5.637-59.753 65.875 56.282 26.129 74.283-86.367-70.812z"
          ></path>
          <path
            strokeWidth="0.16"
            d="M113.775 172.68l54.307 46.144 12.161 43.602M158.843 137.294l34.048 30.694 11.254 22.385M148.817 111.585l29.905 27.277 6.858 14.763M172.652 172.68l41.246 36.333 21.206 41.146M131.019 28.733L325.3 340.847M142.406 39.732l191.206 278.416M153.313 50.27l181.794 248.257"
          ></path>
        </g>
      </g>
    </svg>
  )
};

export default ThemeBg5;
